import { useCallback, useEffect, useRef } from 'react';
import { useSegment } from '@repo/poly-hooks/segment';

export interface UseTrackRenderProps {
  eventName: string;
  params?: Record<string, unknown>;
  delay?: number;
}

export function useTrackRender({ eventName, params = {}, delay }: UseTrackRenderProps): void {
  const segment = useSegment();
  const trackedRef = useRef(false);

  const emitEvent = useCallback(() => {
    segment.track(eventName, params);
    trackedRef.current = true;
  }, [segment, eventName, params]);

  useEffect(() => {
    if (trackedRef.current) return;
    // oxlint-disable-next-line react-you-might-not-need-an-effect/no-event-handler
    if (delay) {
      const timeout = setTimeout(emitEvent, delay);
      return () => {
        clearTimeout(timeout);
      };
    }
    emitEvent();
  }, [emitEvent, delay]);
}
